module.exports = __webpack_public_path__ + "img/availability.cedf6806.svg";